import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { SchoolEntryForm } from "./SchoolForm";
import { PrincipalForm } from "./PrincipalForm";
import { School } from "../../types/School";
import { Principal } from "../../types/Principal";
import { enqueueSnackbar } from "notistack";
import {
  createPrincipal,
  updatePrincipal,
} from "../../services/principalService";
import DbService from "../../services/DbService";
import { useAdmin } from "../../context/AdminContext";
import { useHandleError } from "../../hooks/useHandleError";

export interface SchoolPrincipalCombinedFormProps {
  selectedRow?: School;
  onSubmit: (schoolData: School) => void;
}

const SchoolPrincipalCombinedForm: React.FC<
  SchoolPrincipalCombinedFormProps
> = ({ selectedRow, onSubmit }) => {
  const handleError = useHandleError();
  const { schoolsWithoutPrincipal, refreshSchoolAndPrincipalList } = useAdmin();

  const [principal, setPrincipal] = useState<Principal>();

  useEffect(() => {
    if (selectedRow?.principalId) {
      const getPrincipal = async (id: string) => {
        try {
          const response = await DbService.getPrincipal(id);
          setPrincipal(response.data);
        } catch (error: any) {
          handleError(error);
        }
      };

      getPrincipal(selectedRow.principalId);
    }
  }, [selectedRow]);

  const handlePrincipalSubmit = async (principalData: Principal) => {
    if (principalData._id) {
      try {
        const response = await updatePrincipal(
          principalData._id,
          principalData
        );
        enqueueSnackbar(
          `Principal "${principalData.name}" has been updated successfully`,
          {
            variant: "success",
          }
        );
        //updateSchoolWithPrincipalName(principalData._id, principalData.name);
        setPrincipal(principalData);
        refreshSchoolAndPrincipalList();
      } catch (error) {
        handleError(error);
      }

      return;
    }

    try {
      const response = await createPrincipal(principalData);
      enqueueSnackbar(
        `Principal "${principalData.name}" has been created successfully`,
        {
          variant: "success",
        }
      );

      if (response.data?.id) {
        //updateSchoolWithPrincipalName(response.data.id, response.data.name);
        setPrincipal(response.data);
        refreshSchoolAndPrincipalList();
      }
    } catch (error) {
      handleError(error);
    }
  };

  const updateSchoolWithPrincipalName = (
    principalId: string,
    principalName: string
  ) => {
    if (!selectedRow || selectedRow.principalId == principalId) {
      return;
    }

    onSubmit({ ...selectedRow, principalId, principalName });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <SchoolEntryForm
          school={selectedRow}
          onSubmit={($event) => onSubmit($event)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PrincipalForm
          isCombinedForm={true}
          selectedSchool={selectedRow}
          schools={schoolsWithoutPrincipal}
          selectedRow={principal}
          onSubmit={handlePrincipalSubmit}
        />
      </Grid>
    </Grid>
  );
};

export default SchoolPrincipalCombinedForm;
